/** Why marine insurance can no longer be bought for an LCL shipment (drives the disabled-shield tooltip). */
export enum enumLclInsuranceBlockReason {
  TRACKING_STATE,
  SAILING_WINDOW,
}
